
import React from 'react';
import { Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface PlansActivationProps {
  language: Language;
  promoCode: string;
  setPromoCode: (code: string) => void;
  isActivating: boolean;
  activationStatus: 'idle' | 'success' | 'error';
  onActivate: () => void;
  onStartScan: () => void;
}

const PlansActivation: React.FC<PlansActivationProps> = ({
  language, promoCode, setPromoCode, isActivating, activationStatus, onActivate, onStartScan
}) => {
  const t = TRANSLATIONS[language];

  return (
    <div className="mb-8 relative overflow-hidden rounded-2xl bg-gradient-to-r from-slate-900 to-slate-800 dark:from-white/10 dark:to-white/5 shadow-lg">
      <div className="absolute top-0 right-0 p-3 opacity-10">
        <i className="fas fa-ticket text-6xl text-white"></i>
      </div>
      <div className="p-5 flex flex-col md:flex-row items-center gap-4 relative z-10">
        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white shrink-0">
          <i className="fas fa-key text-sm"></i>
        </div>
        <div className="flex-1 text-center md:text-start">
          <h3 className="text-xs font-black text-white uppercase tracking-widest mb-1">{t.promoTitle}</h3>
          <p className="text-[10px] text-slate-300 font-medium">{t.promoDesc}</p>
        </div>
        <div className="flex items-center gap-2 w-full md:w-auto bg-white/10 p-1.5 rounded-xl border border-white/10">
          <button 
            onClick={onStartScan}
            className="w-8 h-8 flex items-center justify-center text-slate-300 hover:text-white hover:bg-white/10 rounded-lg transition-all"
            title="Scan Code"
          >
            <i className="fas fa-barcode"></i>
          </button>
          <input 
            type="text" 
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
            placeholder="CODE: LAHJA2025"
            className="bg-transparent border-none text-xs font-black text-white placeholder:text-slate-400 focus:ring-0 w-full md:w-32 px-2"
          />
          <button 
            onClick={onActivate}
            disabled={isActivating || !promoCode}
            className="bg-emerald-500 hover:bg-emerald-400 text-white px-4 py-2 rounded-lg text-[10px] font-black transition-all disabled:opacity-50 whitespace-nowrap"
          >
            {isActivating ? <i className="fas fa-spinner fa-spin"></i> : t.activate}
          </button>
        </div>
      </div>
      {/* Status Message */}
      {(activationStatus === 'success' || activationStatus === 'error') && (
        <div className={`text-center py-2 text-[10px] font-bold ${activationStatus === 'success' ? 'bg-emerald-500/20 text-emerald-300' : 'bg-rose-500/20 text-rose-300'}`}>
          {activationStatus === 'success' ? t.promoSuccess : t.promoError}
        </div>
      )}
    </div>
  );
};

export default PlansActivation;
